/**
 * GetAppConfigUseCase
 *
 * Retrieves the app configuration
 * Can be called without authentication
 */

import type { IAppConfigRepository } from '../../domain/repositories/IAppConfigRepository';
import type { AppConfigDTO } from '../dto/AppConfigDTO';
import { AppConfigMapper } from '../mappers/AppConfigMapper';

export class GetAppConfigUseCase {
  constructor(private readonly repository: IAppConfigRepository) {}

  async execute(): Promise<AppConfigDTO> {
    const config = await this.repository.getConfig();
    return AppConfigMapper.toDTO(config);
  }
}
